function OpticsLifecycle() {

    return (
        <p>Optics Lifecycle Bitches</p>
    )

}

export default OpticsLifecycle;